import * as betprofessor from './MiniBetSlip.styles.betprofessor';
import * as sterlingparker from './MiniBetSlip.styles.sterlingparker';
import * as volcanobet from './MiniBetSlip.styles.volcanobet';
import * as puntgenie from './MiniBetSlip.styles.puntgenie';
import * as junglebet from './MiniBetSlip.styles.junglebet';
import * as fiestabet from './MiniBetSlip.styles.fiestabet';
import * as puntcity from './MiniBetSlip.styles.puntcity';
import * as betroyale from './MiniBetSlip.styles.betroyale';
import * as juicybet from './MiniBetSlip.styles.juicybet';
import * as goldenrush from './MiniBetSlip.styles.goldenrush';
import * as wellbet from './MiniBetSlip.styles.wellbet';
import * as questbet from './MiniBetSlip.styles.questbet';
import * as betgalaxy from './MiniBetSlip.styles.betgalaxy';
import * as vikingbet from './MiniBetSlip.styles.vikingbet';
import * as sugarcastle from './MiniBetSlip.styles.sugarcastle';
import * as oldgill from './MiniBetSlip.styles.oldgill';
import * as buffalobet from './MiniBetSlip.styles.buffalobet';
import * as titanbet from './MiniBetSlip.styles.titanbet';
import * as slambet from './MiniBetSlip.styles.slambet';
import * as gigabet from './MiniBetSlip.styles.gigabet';
import * as betstride from './MiniBetSlip.styles.betstride';
import * as goldenbet888 from './MiniBetSlip.styles.goldenbet888';
import * as chromabet from './MiniBetSlip.styles.chromabet';
import * as templebet from './MiniBetSlip.styles.templebet';
import * as hyperbet from './MiniBetSlip.styles.hyperbet';
import * as bet777 from './MiniBetSlip.styles.bet777';
import * as bet575 from './MiniBetSlip.styles.bet575';
import * as epicodds from './MiniBetSlip.styles.epicodds';
import * as pyramidbet from './MiniBetSlip.styles.pyramidbet';
import * as magnumbet from './MiniBetSlip.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  puntgenie,
  betprofessor,
  sterlingparker,
  volcanobet,
  junglebet,
  fiestabet,
  puntcity,
  betroyale,
  juicybet,
  goldenrush,
  wellbet,
  questbet,
  betgalaxy,
  vikingbet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  goldenbet888,
  chromabet,
  templebet,
  hyperbet,
  bet777,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
